import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CremationSection } from '../models/cremation.model';

@Injectable({
  providedIn: 'root'
})
export class CremationService {
  private selectedSectionId = new BehaviorSubject<string | null>(null);
  selectedSection$ = this.selectedSectionId.asObservable();

  private sections: CremationSection[] = [
    {
      id: 'cremation-applications',
      title: 'Anträge zum Download',
      documents: [
        {
          title: 'Antrag Ausnahmegenehmigung',
          downloadUrl: 'assets/download/Antrag Ausnahmegenehmigung.pdf',
          category: 'application'
        },
        {
          title: 'Antrag zur Feuerbestattung',
          downloadUrl: 'assets/download/Antrag zur Feuerbestattung.pdf',
          category: 'application'
        }
      ]
    },
    {
      id: 'cemeteries',
      title: 'Friedhöfe',
      documents: [],
      cemeteryLink: {
        title: 'Zu den Partnerfriedhöfen',
        cemeteryId: 'limes'
      }
    }
  ];

  constructor() {}

  getSections(): CremationSection[] {
    return this.sections;
  }

  setSelectedSection(id: string | null): void {
    this.selectedSectionId.next(id);
  }
}
